import { render, staticRenderFns } from "./KoreanSpecial.vue?vue&type=template&id=63a80733&scoped=true"
import script from "./KoreanSpecial.vue?vue&type=script&lang=js"
export * from "./KoreanSpecial.vue?vue&type=script&lang=js"
import style0 from "./KoreanSpecial.vue?vue&type=style&index=0&id=63a80733&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a80733",
  null
  
)

export default component.exports